import { render, staticRenderFns } from "./NftItemPoolDrop.vue?vue&type=template&id=6e56c659&scoped=true&"
import script from "./NftItemPoolDrop.vue?vue&type=script&lang=ts&"
export * from "./NftItemPoolDrop.vue?vue&type=script&lang=ts&"
import style0 from "./NftItemPoolDrop.vue?vue&type=style&index=0&id=6e56c659&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56c659",
  null
  
)

export default component.exports